import { useModal } from '#app/components/Modals/V2/GlobalModalSystem/useModal.js';
import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { useCallback } from 'react';

// these are places we expect this button to be used
// in the ui—should be accurately tracked
export type FinanceIntegrationUpsellAnalyticsSection =
  | 'bill'
  | 'client_dashboard'
  | 'insights'
  | 'invoice_post_payment'
  | 'paid_project_checkout'
  | 'payment_methods'
  | 'payments'
  | 'project_is_live';

export const useFinanceIntegrationUpsell = ({
  analyticsSection,
}: {
  analyticsSection: string;
}) => {
  const { track } = useAnalytics();
  const { openModal } = useModal({
    identifier: 'FinanceIntegrationClientSubscriptionUpsellModal',
    modalProps: {
      parentAnalyticsSection: analyticsSection,
    },
    staticAdditionalTrackingProperties: {
      section: analyticsSection,
    },
  });

  const openFinanceIntegrationUpsellModal = useCallback(
    ({ section }: { section: FinanceIntegrationUpsellAnalyticsSection }) => {
      track('button', {
        action: 'tapped',
        button_name: 'add_finance_integration',
        section,
      });
      openModal();
    },
    [openModal, track],
  );

  return {
    openFinanceIntegrationUpsellModal,
  };
};
